export default __webpack_public_path__ + "static/media/344.df2c4b3c.gif";